import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { map } from 'rxjs';

import { ButtonModule } from 'primeng/button';

import { AppConfigService } from 'src/app/services/app-config.service';
import { AuthService } from 'src/app/services/auth.service';
import { LaunchDarklyService } from 'src/app/services/launchdarkly.service';
import { SessionService } from 'src/app/services/session.service';
import { environment } from 'src/environments/environment';

/**
 * Displays navigation links to Fenix applications.
 */
@Component({
	selector: 'app-navigation',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.scss'],
	imports: [AsyncPipe, ButtonModule, RouterLink],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationComponent {
	environment = environment;

	public validatdSessionStatus = this.sessionService.validateSession$();

	public isUnderDevelopment$ = this.launchDarklyService.launchDarklyFlags$.pipe(map(flags => flags['under-development']));

	/**
	 * Constructor
	 * @param appConfigService To get current configuration.
	 * @param authService To get user auth state.
	 * @param sessionService To validate current user session.
	 * @param launchDarklyService To get feature flags.
	 */
	constructor(
		public appConfigService: AppConfigService,
		public authService: AuthService,
		private sessionService: SessionService,
		private launchDarklyService: LaunchDarklyService,
	) {}
}
